var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(-499 -255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 24,
    height: 24,
    transform: "translate(499 255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(1707.281 -765.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M-2000,11074.367h14.768",
    transform: "translate(3024.5 -9872.295)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M0,0H9.394",
    transform: "translate(1026.541 1187.201) rotate(90)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M0,0H9.394",
    transform: "translate(1032.23 1187.201) rotate(90)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M0,0H9.394",
    transform: "translate(1037.919 1187.201) rotate(90)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M-1986.918,11070.688l3.526,4.062-3.526,3.985",
    transform: "translate(3024.418 -9872.454)",
    fill: "#15355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M-1983.393,11070.688l-3.526,4.062,3.526,3.985",
    transform: "translate(3010.418 -9872.454)",
    fill: "#15355c"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeading);
export default __webpack_public_path__ + "static/media/leading.f7c9b4503f486d205f07a66569aaba93.svg";
export { ForwardRef as ReactComponent };